// function getCookie(name) {
//   let value = "; " + document.cookie;
//   let parts = value.split("; " + name + "=");
//   if (parts.length == 2) {
//     return parts
//       .pop()
//       .split(";")
//       .shift();
//   }
// }

/**
 * Export
 */
export const baseUrl = "http://52.198.212.96/api/api";
export const routes = {
  auth: "/auth",
  users: "/users",
  orders: "/orders",
  revenue: "/expenditures"
};
// export const token = getCookie("token");